/**
 * In the page there should be one or more listings [data-container-loadmore] with the functionality of the load more [data-btn-loadmore];
 * At the click of the load more button of the listing referenced by its ID, it executes a fetch call in GET
 * The resolution of the PROMISE of the fetch transforms the data into a text with the PROMISE Text()
 * The resolution of the PROMISE Text() gives us the result NOT parsed.
 * At this point we will instantiate a DOM Parser, so that it allows us to parse our result in text / html
 * We take only the elements we want [data-to-append]
 * We verify that the listing to which we will hang the elements received is related to the Load more button clicked
 * I append the elements to the listing.
 *
 * At this point, the button will update with the new href
 * If it doesn't have an href, the button node will be removed
 *
 * */
const initLoadMore = () => {
    const buttonsArray = document.querySelectorAll("[data-btn-loadmore]");
    const dataContainersArray = document.querySelectorAll("[data-container-loadmore]");
    if (buttonsArray && dataContainersArray && buttonsArray.length > 0 && dataContainersArray.length > 0) {
        // Put unique id on data container
        dataContainersArray.forEach((dataContainer, index) => {
            dataContainer.setAttribute("data-container-loadmore", index.toString());
        });
        buttonsArray.forEach((button, index) => {
            //Put unique id on data button load more
            button.setAttribute("data-btn-loadmore", index.toString());
            button.addEventListener("click", (event) => {
                event.preventDefault();
                //start loading animation
                button.classList.add("loading");
                let loadmoreUrl = `${button.href}&partial=1`;
                const listingPageId = button.getAttribute("data-listing-page-id");
                if (listingPageId != null) {
                    loadmoreUrl += `&listing-page-id=${listingPageId}`;
                }
                fetch(`${loadmoreUrl}`)
                    .then(data => {
                    //convert the response into plain text
                    data.text()
                        //resolve the promise
                        .then((result) => {
                        // Initialize the DOM parser
                        const parser = new DOMParser();
                        // Parse the text and convert it into HTML
                        const parsedHTML = parser.parseFromString(result, "text/html");
                        //get only the cards
                        const cardsToAppendArray = parsedHTML.querySelectorAll("[data-to-append]");
                        //append them to the deck
                        const loadMoreButtonId = button.getAttribute("data-btn-loadmore");
                        const dataContainer = document.querySelector(`[data-container-loadmore='${loadMoreButtonId}']`);
                        cardsToAppendArray.forEach(card => {
                            dataContainer.append(card);
                        });
                        //add animation
                        const configCardsAnimationLoadMore = new ConfigCardsAnimation();
                        configCardsAnimationLoadMore.delay = 300;
                        configCardsAnimationLoadMore.cardsToAnimateNodeList = cardsToAppendArray;
                        const cardAnimationLoadMore = new CardAnimation;
                        cardAnimationLoadMore.initCardsAnimation(configCardsAnimationLoadMore);
                        //update loadmore link or hide button
                        const updatedButton = parsedHTML.querySelector("[data-btn-loadmore]");
                        if (updatedButton != null) {
                            button.href = updatedButton.href;
                            //stop loading animation
                            button.classList.remove("loading");
                        }
                        else {
                            //remove load more button
                            button.remove();
                        }
                    });
                });
            });
        });
    }
};
